import { USER_ROLES_RAW_DATA } from "../../roles/types/enums";
import { ROUTES, TableRowData } from "../../shared";
import {
  FEATURE_NAMES,
  ReleaseFeaturesNames
} from "../../shared/featureToggles/types";
import { replaceCamelCaseStringToSeparateWords } from "../../shared/functions/functions";

import { GenerateDesktopTableHeightFunctionType } from "./types";

export const deselectAllRows = (setSelectedRows: any) => {
  setSelectedRows([]);
};

export const deselectSelectedVisibleRows = (
  setSelectedRows: (val: any) => void,
  tableRows: TableRowData[]
) => {
  setSelectedRows((prev: any) =>
    prev.concat(tableRows.map((row: TableRowData) => row.id))
  );
};

export const generateDesktopTableHeight = ({
  hasTabFilters,
  toMd,
  toLg,
  hasSearch,
  hasTableView,
  hasFilteredValues,
  companiesPage,
  filtersHeightValue,
  PAGE_HEADER_HEIGHT,
  NAVBAR_HEIGHT,
  TAB_FILTERS_HEIGHT,
  TABLE_TOOLBAR_HEIGHT,
  DESKTOP_TABLE_FOOTER_HEIGHT
}: GenerateDesktopTableHeightFunctionType) => {
  if (hasTabFilters) {
    if (hasFilteredValues) {
      return `calc(100vh - ${PAGE_HEADER_HEIGHT} - ${NAVBAR_HEIGHT} - ${TAB_FILTERS_HEIGHT} - ${TABLE_TOOLBAR_HEIGHT(
        toMd,
        hasSearch,
        hasTableView
      )} - ${DESKTOP_TABLE_FOOTER_HEIGHT(toLg)} - ${filtersHeightValue}px)`;
    }
    return `calc(100vh - ${PAGE_HEADER_HEIGHT} - ${NAVBAR_HEIGHT} - ${TAB_FILTERS_HEIGHT} - ${TABLE_TOOLBAR_HEIGHT(
      toMd,
      hasSearch,
      hasTableView
    )} - ${DESKTOP_TABLE_FOOTER_HEIGHT(toLg)})`;
  }
  if (companiesPage) {
    return `calc(100vh - ${PAGE_HEADER_HEIGHT} - ${NAVBAR_HEIGHT} - ${TABLE_TOOLBAR_HEIGHT(
      toMd,
      hasSearch,
      hasTableView
    )})`;
  }

  if (hasFilteredValues) {
    return `calc(100vh - ${PAGE_HEADER_HEIGHT} - ${NAVBAR_HEIGHT} - ${TABLE_TOOLBAR_HEIGHT(
      toMd,
      hasSearch,
      hasTableView
    )} - ${DESKTOP_TABLE_FOOTER_HEIGHT(toLg)} - ${filtersHeightValue}px)`;
  }

  return `calc(100vh - ${PAGE_HEADER_HEIGHT} - ${NAVBAR_HEIGHT} - ${TABLE_TOOLBAR_HEIGHT(
    toMd,
    hasSearch,
    hasTableView
  )} - ${DESKTOP_TABLE_FOOTER_HEIGHT(toLg)})`;
};

export const getSelectableRows = (
  route: ROUTES,
  rows: any[],
  user: any,
  isProductionEnv: boolean,
  isReleaseFeatureEnabledForUser: (
    featureName: ReleaseFeaturesNames,
    userRole: string
  ) => any,
  isAllowedToManageData: boolean = true
) => {
  if (route === ROUTES.Users) {
    const isUserHimself = (resourceId: string) => user?.id === resourceId;

    const getRowsBasedOnEnv = (id: string, role: string) => {
      const supportRole = replaceCamelCaseStringToSeparateWords(
        USER_ROLES_RAW_DATA.TeltonikaSupport
      );

      const isAllowedFullControlOfUsers = isReleaseFeatureEnabledForUser(
        FEATURE_NAMES.AllowedFullControlOfUsers,
        user?.email
      );

      if (isProductionEnv) {
        const isNotSupportUser = role !== supportRole;

        return isAllowedFullControlOfUsers
          ? !isUserHimself(id)
          : !isUserHimself(id) && isNotSupportUser;
      }

      return !isUserHimself(id);
    };

    return rows?.filter(({ id, role }: any) => getRowsBasedOnEnv(id, role));
  }
  if (route === ROUTES.Companies) {
    // disable only first row if user is allowed to manage companies data
    const disableOnlyFirstRow =
      isAllowedToManageData && rows?.filter(({ level }: any) => level !== 0);

    // otherwise disable all rows
    return disableOnlyFirstRow || [];
  }

  return rows;
};

export const isRowDisabled = (selectableRows: any, rowData: any) =>
  !selectableRows.some((selectableRow: any) => selectableRow.id === rowData.id);
